import React from 'react';

interface Props {
  contactDetail: string;
}
const contactDetailToArray = (contactDetail: string) => contactDetail.split('\\n');

export const formatContactDetail = ({ contactDetail }: Props) => {
  return contactDetailToArray(contactDetail).map(line => (
    <React.Fragment key={line}>
      {line}
      <br />
    </React.Fragment>
  ));
};
